import * as React from 'react';

import {
    NOS_BUSINESS_SIGN_UP_REFERRAL_SET_EVENT,
    NOS_BUSINESS_SIGN_UP_REFERRAL_SOURCE_KEY,
    NOS_BUSINESS_SIGN_UP_REFERRAL_SOURCE_PARAM
} from '../../configuration/business-sign-up';
import { INosReferralRegistrationData } from './nos-referral-registration.data';
import { INosReferralRegistrationProps } from './nos-referral-registration.props.autogenerated';

export interface INosReferralRegistrationViewProps extends INosReferralRegistrationProps<INosReferralRegistrationData> {}

/**
 *
 * NosReferralRegistration component
 * @extends {React.PureComponent<INosReferralRegistrationProps<INosReferralRegistrationData>>}
 */
class NosReferralRegistration extends React.PureComponent<INosReferralRegistrationProps<INosReferralRegistrationData>> {
    public componentDidMount(): void {
        if (typeof window === 'undefined') {
            return;
        }

        const href = window.location.href;
        const param = NOS_BUSINESS_SIGN_UP_REFERRAL_SOURCE_PARAM;
        const value = this._getQueryParam(href, param);

        if (value) {
            try {
                if (typeof sessionStorage !== 'undefined') {
                    sessionStorage.setItem(NOS_BUSINESS_SIGN_UP_REFERRAL_SOURCE_KEY, value);
                }
                if (typeof window !== 'undefined') {
                    window.dispatchEvent(new CustomEvent(NOS_BUSINESS_SIGN_UP_REFERRAL_SET_EVENT, { detail: value }));
                }
            } catch (e) {
                console.warn('Unable to persist referral source', e);
            }
        }
    }

    private _getQueryParam(href: string, paramName: string): string {
        const lowerParam = paramName.toLowerCase();

        const getFromSearchParams = (searchParams: URLSearchParams): string | null => {
            let found: string | null = null;
            searchParams.forEach((v, k) => {
                if (found === null && k.toLowerCase() === lowerParam) {
                    found = v || null;
                }
            });
            return found;
        };

        const tryUrlParsing = (candidate: string): string | null => {
            try {
                const u = new URL(candidate);
                const val = getFromSearchParams(u.searchParams);
                if (val) {
                    return val;
                }
            } catch (_) {
                // Not a full absolute URL or parsing failed; fall through
            }

            // If a '?' exists, try parsing the query substring
            const qIdx = candidate.indexOf('?');
            if (qIdx >= 0) {
                try {
                    const qs = candidate.slice(qIdx + 1);
                    const sp = new URLSearchParams(qs);
                    const val = getFromSearchParams(sp);
                    if (val) {
                        return val;
                    }
                } catch (_) {
                    // ignore
                }
            }
            return null;
        };

        // Try original href
        let result = tryUrlParsing(href);
        if (result) {
            return this._safeDecode(result);
        }

        // Try single decode (handles encoded '?', e.g. %3F)
        try {
            const decoded1 = decodeURIComponent(href);
            result = tryUrlParsing(decoded1);
            if (result) {
                return this._safeDecode(result);
            }
        } catch (_) {
            // ignore decode errors
        }

        // Try double decode (handles double-encoded scenarios)
        try {
            const decoded2 = decodeURIComponent(decodeURIComponent(href));
            result = tryUrlParsing(decoded2);
            if (result) {
                return this._safeDecode(result);
            }
        } catch (_) {
            // ignore
        }

        try {
            const decoded = decodeURIComponent(href);
            // eslint-disable-next-line security/detect-non-literal-regexp
            const re = new RegExp(`[?&]${paramName}=([^&#]*)`, 'i');
            const m = decoded.match(re);
            if (m && m[1]) {
                return this._safeDecode(m[1]);
            }
        } catch (_) {
            // ignore
        }

        return '';
    }

    private _safeDecode(value: string): string {
        if (!value) {
            return '';
        }
        try {
            return decodeURIComponent(value);
        } catch (_) {
            return value;
        }
    }

    public render(): JSX.Element | null {
        return null;
    }
}

export default NosReferralRegistration;
